import React from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import { XIcon, EyeIcon, EyeOffIcon } from "@heroicons/react/solid";
import Button from '../../components/ui/Button';
import useGeneratePassword from '../../hooks/employeeDetails/useGeneratePassword';
import InlineLoader from '../../components/loader/InlineLoader';

const GeneratePasswordModal = ({ open, onClose, company_employee_id }) => {
  const {
    password,
    showPassword,
    isSubmitting,
    passwordError,
    togglePasswordVisibility,
    handlePasswordChange,
    handleSavePassword,
    handleGeneratePassword
  } = useGeneratePassword({ 
    company_employee_id,
    onClose
  });

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        borderRadius: '8px',
        boxShadow: 24,
        p: 4,
      }}>
        <div className="flex justify-between items-center mb-4">
          <Typography variant="h6" component="h2" className="font-bold text-lg">
            Create Password
          </Typography>
          <IconButton onClick={onClose} size="small">
            <XIcon className="h-5 w-5" />
          </IconButton>
        </div>

        <div className="mb-6">
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={handlePasswordChange}
                placeholder="Enter password"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                {showPassword ? (
                  <EyeOffIcon 
                    className="h-5 w-5 text-gray-500 cursor-pointer" 
                    onClick={togglePasswordVisibility}
                  />
                ) : (
                  <EyeIcon 
                    className="h-5 w-5 text-gray-500 cursor-pointer" 
                    onClick={togglePasswordVisibility}
                  />
                )}
              </div>
            </div>
            {passwordError && (
              <p className="text-sm text-red-500 mt-1">{passwordError}</p>
            )}
          </div>
        </div>

        <div className="flex justify-end space-x-3">
          <Button 
            variant="outline" 
            size="default"
            onClick={handleGeneratePassword}
          >
            Generate Password
          </Button>
          <Button 
            variant="default" 
            size="default"
            onClick={handleSavePassword}
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <div className="flex items-center gap-2">
                <InlineLoader className="text-current" /> Saving...
              </div>
            ) : 'Save'}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default GeneratePasswordModal;
